import React from "react";

function getUrl(quilt: boolean, name?: string): string {
    if (name === undefined || name.length === 0) {
        if (quilt) {
            return `api/panty/quilt/random?token=${new Date().getTime()}`;
        } else {
            return `api/panty/random?token=${new Date().getTime()}`;
        }
    }

    if (quilt) {
        return `api/panty/quilt?name=${encodeURIComponent(name)}`;
    } else {
        return `api/panty?name=${encodeURIComponent(name)}`;
    }
}

export function Generator(): React.ReactElement {
    const [quilt, setQuilt] = React.useState(true);
    const [loading, setLoading] = React.useState(true);
    const [name, setName] = React.useState("Twisted Knickers Rally");
    const [url, setUrl] = React.useState<string>(() => getUrl(quilt, name));

    const onRandom = () => {
        setLoading(true);
        setName("");
        setUrl(getUrl(quilt));
    };

    const onSubmit = () => {
        const trimmedName = name.trim();
        if (trimmedName.length === 0) {
            return;
        }

        const newUrl = getUrl(quilt, trimmedName);
        if (newUrl === url) {
            return;
        }

        setLoading(true);
        setUrl(newUrl);
    };

    const onLoadComplete = () => setLoading(false);

    const onQuiltedChanged = (value: boolean) => {
        setQuilt(value);
        setUrl(getUrl(value, name));
    }

    return <div className="GeneratorContainer">
        <div className="InputContainer">
            <input type="text" value={name} onChange={e => setName(e.target.value)} />
            <input className="QuiltedMargin" type="checkbox" id="quilted" name="quilted" checked={quilt} onChange={e => onQuiltedChanged(e.target.checked)} />
            <label htmlFor="quilted">Quilt pattern?</label>
        </div>
        <div className="InputContainer">
            <button className="InputItem" onClick={onSubmit}>Panties for my name!</button>
            <button className="InputItem" onClick={onRandom}>I'm Feeling Lucky</button>
        </div>

        {loading && <div className="Loading">Making some nice panties for you...</div>}
        {url !== undefined && <img key={url} className={"PantyImage"} src={url} alt="panties" onLoad={onLoadComplete}></img> }
    </div>
}